import styled from 'styled-components';

export const Base = styled.div`
	display: flex;
	flex-direction: column;
`;

export const Row = styled.button<{ $selected: boolean }>`
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 6px 8px;
	width: 100%;
	border: none;
	border-bottom: 1px solid ${({ theme }) => theme.gray[200]};
	background-color: ${({ theme, $selected }) => ($selected ? theme.blue[300] : 'transparent')};
	transition: background-color 0.15s ease;
	text-align: left;
	font: inherit;

	&:hover {
		background-color: ${({ theme, $selected }) =>
			$selected ? theme.blue[300] : theme.gray[100]};
	}

	&:last-child {
		border-bottom: none;
	}
`;

export const Swatch = styled.div<{ $color: string }>`
	width: 24px;
	height: 24px;
	border-radius: 6px;
	background-color: ${({ $color }) => $color};
	border: 1px solid ${({ theme }) => theme.gray[200]};
	flex-shrink: 0;
`;

export const Name = styled.div`
	font-size: 13px;
	font-weight: 500;
	color: ${({ theme }) => theme.gray[900]};
	min-width: 120px;
`;

export const Variable = styled.div`
	font-size: 11px;
	color: ${({ theme }) => theme.gray[600]};
	font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono',
		'Courier New', monospace;
	flex: 1;
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

export const Hex = styled.div`
	font-size: 11px;
	color: ${({ theme }) => theme.gray[700]};
	font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono',
		'Courier New', monospace;
	flex-shrink: 0;
	min-width: 70px;
	text-align: right;
`;
